import { faChevronLeft, faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";

import { IconButton } from "@aviary";
import { l } from "@shared/locales/i18n";
import { FontAwesomeIcon } from "@shared/react-fontawesome";

import * as styles from "./NavigationButtons.styles";

interface Props {
  backDisabled: boolean;
  nextDisabled: boolean;
  forceShow?: boolean;
  onBack: () => void;
  onNext: () => void;
}

const NavigationButtons = ({ backDisabled, nextDisabled, onBack, onNext, forceShow }: Props) => {
  const { t } = useTranslation();

  if (backDisabled && nextDisabled && !forceShow) {
    return null;
  }

  return (
    <div css={styles.navigationButtons}>
      <IconButton
        data-testid="back-button"
        onClick={onBack}
        disabled={backDisabled}
        isText
        isColor="system"
        aria-label={t(l.sharedCommon.Back)}
        css={styles.iconButton}
      >
        <FontAwesomeIcon icon={faChevronLeft} size="sm" css={styles.iconChev} />
      </IconButton>
      <IconButton
        data-testid="next-button"
        onClick={onNext}
        disabled={nextDisabled}
        isText
        isColor="system"
        aria-label={t(l.sharedCommon.Next)}
        css={styles.iconButton}
      >
        <FontAwesomeIcon icon={faChevronRight} size="sm" css={styles.iconChev} />
      </IconButton>
    </div>
  );
};

export { NavigationButtons };
